import _ from "lodash";

import { Action } from "../../../actions/actions";
import { HallsActionTypes } from "../actions/actionTypes";
import { HallServer } from "./inspectingHall.reducer";

export const STARTING_PAGE = 0;
export const PAGE_SIZE = 12;

interface HallsListState {
    halls: HallBaseConfig[];
    total: number;
    timestamp: number;
}

export interface HallLicense {
    server_id: number;
    duration: number;
    warning_period: number;
    generation: string | null;
    expiration: string | null;
    automated: boolean;
    hall_id: number;
    id: number;
}

export interface HallBaseConfig {
    id: number;
    name: string;
    active: boolean;
    address_line_1: string;
    address_line_2: string;
    country: string;
    created_on: string;
    subsidiary?: any;
    servers?: HallServer[];
    licenses?: HallLicense[];
    deleted?: boolean;
    timezone?: any;
    allow_license_renew?: boolean;
    hall_code?: any;
    renewal_trigger_days?: number;
    dynamics_status ?: string;
    allow_license_automatic_renew?: boolean;
}

const initialState: HallsListState = {
    halls: [],
    total: 0,
    timestamp: 0
};

export function hallsList(
    state: HallsListState = initialState,
    action: Action
): HallsListState {
    switch (action.type) {
        case HallsActionTypes.TOGGLE_HALL_ACTIVE_SUCCESS:
            let newState: HallsListState = _.cloneDeep(state);
            const index = _.findIndex(newState.halls, [
                "id",
                action.payload.hallId
            ]);
            if (index > -1) {
                newState.halls[index].active = !newState.halls[index].active;
                return newState;
            } else {
                return newState;
            }
        case HallsActionTypes.GET_HALLS_LIST_SUCCESS:
            return {
                halls: action.payload.halls.results.map(hall => ({
                    ...hall,
                    servers: action.payload.servers.results
                        ? action.payload.servers.results
                              .filter(server => server.hall_id === hall.id)
                              .map(server => {
                                  return {
                                      ...server,
                                      license: mapLicenses(
                                          action.payload.licenses.results,
                                          server
                                      )
                                  };
                              })
                        : []
                })),

                total: action.payload.halls.count,
                timestamp: new Date().getTime()
            };
        default:
            return state;
    }
}

function mapLicenses(licenses, server) {
    let severLicenses = licenses.filter(license => {
        return license.server_license_state.server_id == server.id;
    });

    if (severLicenses.length > 0) {
        return severLicenses[0];
    } else {
        return undefined;
    }
}

export function hallsListLoading(
    state: boolean = false,
    action: Action
): boolean {
    switch (action.type) {
        case HallsActionTypes.GET_HALLS_LIST:
            return true;
        case HallsActionTypes.GET_HALLS_LIST_SUCCESS:
        case HallsActionTypes.GET_HALLS_LIST_FAIL:
            return false;
        default:
            return state;
    }
}
